export const events = {
  createJobOpeningStart: 'Create new job opening start',
  createJobOpeningCancel: 'Create new job opening cancel',
  createJobOpeningSubmit: 'Create new job opening submit',
  publishJobOpeningSubmit: 'Publish job opening submit',
  publishJobOpeningCancel: 'Publish job opening cancel',
  publishJobOpeningStart: 'Publish job opening start',
  requestJobOpeningStart: 'Request new job opening start',
  requestJobOpeningCancel: 'Request new job opening cancel',
  requestJobOpeningSubmit: 'Request new job opening submit',
  editJobDetailsTabSubmit: 'Edit job details tab submit',
  goToCandidatePersonal: 'Go to candidate personal',
  goToUpgradeNow: 'Go to upgrade now',
  addCandidateToJobOpeningStart: 'Add candidate to job opening start',
  addCandidateToJobOpeningCancel: 'Add candidate to job opening cancel',
  addCandidateToJobOpeningSubmit: 'Add candidate to job opening submit',
  addCandidateToTalentPool: 'Add candidate to talent pool',
  openWhatsappChatWithCandidate: 'Open a Whatsapp conversation with a candidate',
  sendPhoneCallWithCandidate: 'Send a push notification to call a candidate',
  createTag: 'Create new tag',
  addTagToCandidate: 'Add tag to candidate',
  filterCandidatesByTag: 'Filter candidates by tag',
  filterApplicationsByTag: 'Filter applications by tag',
  upgradeModalView: 'Upgrade modal view',
  copyJobOpeningsIframeUrl: 'Copy job openings iframe URL',
  goToMessageInbox: 'Go to message inbox',
  smartActionCreate: 'Smart action create',
  smartActionActivate: 'Smart action activate',
  smartActionPerform: 'Smart action perform',
  smartActionEdit: 'Smart action edit',
  enableOpenApplications: 'Allow candidates to apply when no job opening suits their profile',
  disableOpenApplications:
    'Restrict candidates from applying when no job opening suits their profile',
  insightsMainPageView: 'Recruitment insights page views',
  insightsSourcesView: 'Recruitment insights sources view',
  insightsGenderView: 'Recruitment insights genders view',
  insightsTeamsFilter: 'Recruitment insights teams filtering',
  insightsJobPostingsFilter: 'Recruitment insights job postings filtering',
  insightsHiringStagesReportDownload: 'Recruitment insights hiring stages report downloaded',
  insightsSourcesReportDownload: 'Recruitment insights source report downloaded',
  cvBulkUploadInitiated: 'Cv bulk upload initiated',
  cvBulkUploadRequested: 'Cv bulk upload requested',
  cvBulkUploadCancelled: 'Cv bulk upload cancelled',
  cvBulkUploadApplicantsInitiated: 'Cv bulk upload applicants initiated',
  cvBulkUploadApplicantsRequested: 'Cv bulk upload applicants requested',
  cvBulkUploadApplicantsCancelled: 'Cv bulk upload applicants cancelled',
  candidateAddedToJobPosting: 'Candidate added to a job',
  candidatesPageView: 'Candidates page view',
  candidatesPageTalentPoolView: 'Candidates talent pool tab view',
  newCandidatesPageView: 'New candidates page view',
  infojobsPromotionInitiated: 'Infojobs promotion initiated',
  infojobsPromotionFinalized: 'Infojobs promotion finalized',
  infojobsPromotionCancelled: 'Infojobs promotion cancelled',
  jobSettingsAccessBasicInformation: 'Job settings access basic information',
  jobSettingsAccessDescription: 'Job settings access description',
  jobSettingsAccessApplicationForm: 'Job settings access application form',
  jobSettingsAccesHiringPipeline: 'Job settings access hiring pipeline',
  jobSettingsAccessHiringTeam: 'Job settings access hiring team',
  jobSettingsAccessEvaluationForm: 'Job settings access evaluation form',
  jobSettingsAccessSmartActions: 'Job settings access smart actions',
  jobSettingsJobCreateModalNext: 'Job settings job create modal click next',
  jobSettingsDescriptionSubmit: 'Job settings description submit',
  jobSettingsApplicationFormSubmit: 'Job settings application form submit',
  jobSettingsAddApplicationQuestion: 'Job settings add application question',
  jobSettingsAddEvaluationForm: 'Job settings add evaluation form',
  reviewerCandidateViewed: 'HM with reviewer role views a candidate',
  hiringRoleEdited: 'Change the role of a hiring manager',
  candidateMovedPhase: 'Move a candidate to a different phase',
  visitHiringTeam: 'Visit the hiring team in job posting settings',
  premiumOfferPurchased: 'Premium offer purchased',
}
